const getLocalizedPlugin = function(plugin, serverItem = {}, language = 'en'){
  const german = language === 'de';
  return {
    ...serverItem,
    pluginId: plugin.id,
    toolkitSlug: plugin.toolkitSlug,
    name: plugin.name,
    icon: plugin.icon,
    description: german ? plugin.descriptionDe : plugin.description,
    keywords: plugin.keywords,
    capabilityCopy: {
      read: german ? plugin.readDescriptionDe : plugin.readDescription,
      write: german ? plugin.writeDescriptionDe : plugin.writeDescription,
      writeBlocked: german ? plugin.noWriteDescriptionDe : plugin.noWriteDescription,
    },
    supportsWrite: plugin.supportsWrite !== false && serverItem.supportsWrite !== false,
    active: serverItem.active !== false,
    configured: serverItem.configured !== false,
    custom: false,
  };
};

const buildCuratedPluginCatalog = function(catalogPluginList = [], serverPluginList = [], language = 'en'){
  return catalogPluginList
    .map(plugin => getLocalizedPlugin(
      plugin,
      serverPluginList.find(serverItem => serverItem.pluginId === plugin.id) || {},
      language
    ))
    .filter(pluginItem => pluginItem.active === true && pluginItem.configured === true);
};

export { buildCuratedPluginCatalog, getLocalizedPlugin };
